import { render } from "./yearlyGrowth2.vue?vue&type=template&id=2a5f9747"
import script from "./yearlyGrowth2.vue?vue&type=script&lang=js"
export * from "./yearlyGrowth2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__